import { useState } from 'react';
import { FETCH_STATUS } from '@hooks/useSWRFetch/types';
import { CreateCatalogExportRequest__Output } from '@generated/grpc/spotify/catalogexport/v1';

export const useCreateCatalogExport = () => {
  const [status, setStatus] = useState<FETCH_STATUS>(FETCH_STATUS.IDLE);

  const createCatalogExportRequest = async (
    createCatalogExportDetails: CreateCatalogExportRequest__Output,
  ) => {
    setStatus(FETCH_STATUS.FETCHING);
    const shouldRequest =
      createCatalogExportDetails &&
      !!createCatalogExportDetails.exportType &&
      !!createCatalogExportDetails.startDate &&
      !!createCatalogExportDetails.endDate &&
      !!createCatalogExportDetails.feedIds &&
      !!createCatalogExportDetails.licensorIds &&
      !!createCatalogExportDetails.languageLocale;

    if (shouldRequest) {
      try {
        const res = await fetch('/catalog/api/catalogexport', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(createCatalogExportDetails),
        });

        setStatus(FETCH_STATUS.SUCCESS);
        if (!res.ok) {
          setStatus(FETCH_STATUS.ERROR);
          return '';
        }
        const json = await res.json();
        return json.destinationEmailAddress;
      } catch (error) {
        setStatus(FETCH_STATUS.ERROR);
        return '';
      }
    }

    setStatus(FETCH_STATUS.ERROR);

    return '';
  };

  return {
    status,
    actions: {
      createCatalogExportRequest,
    },
  };
};
